export default __webpack_public_path__ + "static/media/gucci.2911723c.jpg";